import { render, staticRenderFns } from "./ConsumptionNotificationRow.vue?vue&type=template&id=4d0ffeb0&scoped=true&"
import script from "./ConsumptionNotificationRow.vue?vue&type=script&lang=js&"
export * from "./ConsumptionNotificationRow.vue?vue&type=script&lang=js&"
import style0 from "./ConsumptionNotificationRow.vue?vue&type=style&index=0&id=4d0ffeb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ffeb0",
  null
  
)

export default component.exports